// NATIVE

// INSTALLED
import { setCargosRedux, setCargosSelectRedux, storeCargoRedux } from './cargoSlice';
import { checkingPreload, unCheckingPreload } from '../loading';

// CUSTOM
import { setAreasRedux } from '../areas';
import {
  activeCargoService,
  createCargoService,
  desactiveCargoService,
  getCargoDetailService,
  getCargosByPaginateService,
  getCargosSelectService,
  getCargosService,
  updateCargoDetailService,
} from '../../services/cargo.service';

export const getOnlyCargosSelectStore = (): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());

    const result = await getCargosSelectService();

    if (result.ok) {
      await dispatch(setCargosSelectRedux(result.data));
    }

    dispatch(unCheckingPreload());

    return result;
  };
};

export const getCargosStore = (): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());

    const result = await getCargosService();

    console.log(result);
    if (result.ok) {
      await dispatch(setCargosRedux(result.data.data));
      await dispatch(setAreasRedux(result.data.areas));
    }

    dispatch(unCheckingPreload());

    return result;
  };
};

export const getCargosByPagination = (page: number): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());

    const result = await getCargosByPaginateService(page);

    console.log(result);
    if (result.ok) {
      await dispatch(setCargosRedux(result.data.data));
    }

    dispatch(unCheckingPreload());

    return result;
  };
};

export const storeCreateCargo = (cargo: any, percentage: any): any => {
  return async (dispatch: any) => {
    const dataCargo = {
      name: cargo.name,
      description: cargo.description,
      areaId: cargo.area.value,
      visita_domiciliaria: cargo.visita_domiciliaria ? cargo.visita_domiciliaria : false,
      prueba_psicotecnica: cargo.prueba_psicotecnica ? cargo.prueba_psicotecnica : false,
      examen_alimentos: cargo.examen_alimentos ? cargo.examen_alimentos : false,
      examen_alturas: cargo.examen_alturas ? cargo.examen_alturas : false,
      certificado_laboral: cargo.certificado_laboral ? cargo.certificado_laboral : false,
      certificado_estudios: cargo.certificado_estudios ? cargo.certificado_estudios : false,
      adres: cargo.adres ? cargo.adres : false,
      antecedentes_judicial: cargo.antecedentes_judicial ? cargo.antecedentes_judicial : false,
      entrevista: cargo.entrevista ? cargo.entrevista : false,
      sociodemografica: cargo.sociodemografica ? cargo.sociodemografica : false,
      dme: cargo.dme ? cargo.dme : false,
      sst: cargo.sst ? cargo.sst : false,
    };

    const result = await createCargoService(dataCargo, percentage);

    if (result.ok) {
      await dispatch(setCargosRedux(result.data));
    }

    return result;
  };
};

export const storeDetailCargos = (cargoId: string): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());

    const result = await getCargoDetailService(cargoId);

    if (result.ok) {
      await dispatch(storeCargoRedux(result.data.cargo));
      await dispatch(setAreasRedux(result.data.areas));
    }

    dispatch(unCheckingPreload());

    return result;
  };
};

export const storeEditCargo = (cargo: any): any => {
  return async (dispatch: any) => {
    const data_save = {
      name: cargo.e_name,
      description: cargo.e_description,
      areaId: cargo.e_area.value,
      visita_domiciliaria: cargo.e_visita_domiciliaria ? true : false,
      prueba_psicotecnica: cargo.e_prueba_psicotecnica ? true : false,
      examen_alimentos: cargo.e_examen_alimentos ? true : false,
      examen_alturas: cargo.e_examen_alturas ? true : false,
      certificado_laboral: cargo.e_certificado_laboral ? true : false,
      certificado_estudios: cargo.e_certificado_estudios ? true : false,
      adres: cargo.e_adres ? true : false,
      antecedentes_judicial: cargo.e_antecedentes_judicial ? true : false,
      entrevista: cargo.e_entrevista ? true : false,
      sociodemografica: cargo.e_sociodemografica ? true : false,
      dme: cargo.e_dme ? true : false,
      sst: cargo.e_sst ? true : false,
      cargoId: cargo.cargoId,
    };

    const result = await updateCargoDetailService(data_save);

    if (result.ok) {
      await dispatch(setCargosRedux(result.data));
    }

    return result;
  };
};

export const storeDesactiveCargo = (cargoId: string): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());

    const result = await desactiveCargoService(cargoId);

    if (result.ok) {
      await dispatch(setCargosRedux(result.data));
    }

    dispatch(unCheckingPreload());

    return result;
  };
};

export const storeActiveCargo = (cargoId: string): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());

    const result = await activeCargoService(cargoId);

    if (result.ok) {
      await dispatch(setCargosRedux(result.data));
    }

    dispatch(unCheckingPreload());

    return result;
  };
};
